export default __webpack_public_path__ + "static/media/tableware_cat_disabled.a7390a12.jpg";